module.exports = __webpack_public_path__ + "static/img/04.fc674c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/companyLogo/04.png
// module id = ryie
// module chunks = 1